/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateTransferLineItem,
  CreateTransferLineItem$inboundSchema,
  CreateTransferLineItem$Outbound,
  CreateTransferLineItem$outboundSchema,
} from "./createtransferlineitem.js";

/**
 * An optional collection of line items for a transfer.
 *
 * @remarks
 * When line items are provided, their total plus sales tax must equal the transfer amount.
 */
export type CreateTransferLineItems = {
  /**
   * The list of line items.
   */
  items: Array<CreateTransferLineItem>;
};

/** @internal */
export const CreateTransferLineItems$inboundSchema: z.ZodType<
  CreateTransferLineItems,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(CreateTransferLineItem$inboundSchema),
});
/** @internal */
export type CreateTransferLineItems$Outbound = {
  items: Array<CreateTransferLineItem$Outbound>;
};

/** @internal */
export const CreateTransferLineItems$outboundSchema: z.ZodType<
  CreateTransferLineItems$Outbound,
  z.ZodTypeDef,
  CreateTransferLineItems
> = z.object({
  items: z.array(CreateTransferLineItem$outboundSchema),
});

export function createTransferLineItemsToJSON(
  createTransferLineItems: CreateTransferLineItems,
): string {
  return JSON.stringify(
    CreateTransferLineItems$outboundSchema.parse(createTransferLineItems),
  );
}
export function createTransferLineItemsFromJSON(
  jsonString: string,
): SafeParseResult<CreateTransferLineItems, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateTransferLineItems$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateTransferLineItems' from JSON`,
  );
}
